import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface AcknowledgeUserIdentityConflictsParams {
    ids: string[];
}

export class AcknowledgeUserIdentityConflictsRequest extends Request<AcknowledgeUserIdentityConflictsParams, IResult> {
  constructor(params: AcknowledgeUserIdentityConflictsParams) {
    super('acknowledgeUserIdentityConflicts', params);
  }
}
